<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>回归配置</span>
          <CommonExport
            :import-p="'config:recall:import'"
            :export-p="'config:recall:export'"
            :import-method="importRecall"
            :export-method="exportRecall"
            :get-table="getTables"
          />
          <!--          <syncVersion :in-method="uploadrecallJson" :params="params" />-->

          <clear-cache-apply />
        </div>

        <el-card>
          <el-tabs v-model="activeName" tab-position="left" @tab-click="handleClick">
            <el-tab-pane label="条件配置" :name="name">
              <el-form :model="commonCfg" class="demo-form-inline">
                <el-form-item label="离线时间(天)">
                  <el-input v-model.number="commonCfg.lostTimes" style="width: 250px;" placeholder="离线时间" />
                </el-form-item>
                <el-form-item label="等级范围">
                  <el-input v-model.number="commonCfg.minLv" style="width: 250px;" placeholder="最小等级" />
                  <span class="span-row">-</span>
                  <el-input v-model.number="commonCfg.maxLv" style="width: 250px;" placeholder="最大等级" />
                </el-form-item>
                <el-form-item label="支付金额范围">
                  <el-input v-model.number="commonCfg.minPay" style="width: 250px;" placeholder="最小金额" />
                  <span class="span-row">-</span>
                  <el-input v-model.number="commonCfg.maxPay" style="width: 250px;" placeholder="最大金额" />
                </el-form-item>
              </el-form>
              <el-button type="primary" @click="commonOnSubmit">保存</el-button>
            </el-tab-pane>
            <el-tab-pane label="召回时间" :name="name2">
              <el-form :model="commonCfg" class="demo-form-inline">
                <el-form-item label="时间范围">
                  <el-date-picker v-model="commonCfg.startTime" value-format="yyyy-MM-dd HH:mm:ss" type="datetime" style="width: 200px" placeholder="开始时间" />
                  <span class="span-row">-</span>
                  <el-date-picker v-model="commonCfg.endTime" value-format="yyyy-MM-dd HH:mm:ss" type="datetime" style="width: 200px" placeholder="开始时间" />
                </el-form-item>
              </el-form>
              <el-button type="primary" @click="commonOnSubmit">保存</el-button>
            </el-tab-pane>
          </el-tabs>
        </el-card>
        <el-table size="mini" style="margin-top: 20px;" :data="formData" border stripe>
          <el-table-column prop="id" label="ID">
            <template v-slot:default="scope">
              <span>{{ scope.row.id }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="moneyIncome" label="等级最小值">
            <template v-slot:default="scope">
              <el-input v-model.number="scope.row.minLv" size="mini" />
            </template>
          </el-table-column>
          <el-table-column prop="diamondCapacity" label="等级最大值">
            <template v-slot:default="scope">
              <el-input v-model.number="scope.row.maxLv" size="mini" />
            </template>
          </el-table-column>
          <el-table-column prop="rewards" label="奖励">
            <template v-slot:default="scope">
              <Reward :value="scope.row.rewards" />
            </template>
          </el-table-column>
          <el-table-column label="操作" width="120px">
            <template v-slot:default="scope">
              <el-button v-permisaction="['config:recall:del']" type="danger" @click="del(scope.row.id)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div style="margin-top: 10px;text-align: center">
          <el-button v-permisaction="['config:recall:add']" type="primary" @click="add()">+</el-button>
          <el-button v-permisaction="['config:recall:add']" type="primary" @click="onSubmit()">保存</el-button>
        </div>

        <pagination
          v-show="total>0"
          background
          :page.sync="queryParams.pageIndex"
          :limit.sync="queryParams.pageSize"
          :total="total"
          @pagination="getTables"
        />
      </el-card>

    </template>
  </BasicLayout>
</template>

<script>
import { getCommonCfg, updateCommonCfg } from '@/api/config/common-cfg'
import ClearCacheApply from '@/components/clear_cache_apply/index.vue'
import Reward from '@/components/Reward/index.vue'
import CommonExport from '@/components/CommonExport/index.vue'
import { delRecall, exportRecall, getRecallList, importRecall, updateRecallCfg } from '@/api/config/recall-cfg'
export default {
  name: 'RecallConfig',
  components: { CommonExport, Reward, ClearCacheApply },
  data() {
    return {
      activeName: 'RETURNS_BASIC_KEY',
      name: 'RETURNS_BASIC_KEY',
      name2: 'RETURNS_REWARDS_TIMES_KEY',
      params: { name: 'RETURNS_BASIC_KEY' },
      loading: false,
      total: 0,
      queryParams: {
        pageIndex: 1,
        pageSize: 10
      },
      commonCfg: {
        id: 0,
        lostTimes: 0,
        minLv: 0,
        maxLv: 0,
        minPay: 0,
        maxPay: 0
      },
      formData: [{
        id: 0,
        minLv: 0,
        maxLv: 0,
        rewards: []
      }]
    }
  },
  created() {
    this.getTables()
    this.getCommonConf()
  },
  methods: {
    importRecall,
    exportRecall,
    handleClick() {
      this.getCommonConf()
    },
    commonOnSubmit() {
      switch (this.activeName) {
        case this.name:
          if (this.commonCfg.minLv > this.commonCfg.maxLv) {
            this.msgError('最小等级不能大于最大等级')
            return
          }
          if (this.commonCfg.minPay > this.commonCfg.maxPay) {
            this.msgError('最小金额不能大于最大金额')
            return
          }
          break
        case this.name2:
          if (!this.commonCfg.startTime || !this.commonCfg.endTime) {
            this.msgError('请选择时间范围')
            return
          }
          if (this.commonCfg.startTime > this.commonCfg.endTime) {
            this.msgError('开始时间不能大于结束时间')
            return
          }
          break
      }

      const data = JSON.stringify(this.commonCfg)
      updateCommonCfg({ name: this.activeName, data: data }).then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getCommonConf()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    onSubmit() {
      for (const i in this.formData) {
        const _data = this.formData[i]
        if (!_data.minLv) {
          this.msgError('最小等级不能是0')
          return
        }

        if (!_data.maxLv) {
          this.msgError('最大等级不能是0')
          return
        }
        if (_data.minLv > _data.maxLv) {
          this.msgError('最小等级不能大于最大等级')
          return
        }
      }
      const data = JSON.stringify(this.formData)
      console.log('data', data)
      updateRecallCfg({ data: data }).then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    getTables() {
      this.loading = true
      getRecallList(this.queryParams).then(res => {
        this.loading = false
        if (res.code === 200) {
          this.formData = res.data.list
          this.total = res.data.count
        } else {
          this.msgError(res.msg)
        }
      })
    },
    getCommonConf() {
      getCommonCfg({ name: this.activeName }).then(res => {
        this.commonCfg = res.data
      })
    },
    add() {
      this.formData.push({
        id: 0,
        minLv: 0,
        maxLv: 0,
        rewards: []
      })
    },
    del(id) {
      this.$confirm('确认要删除吗?', '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        delRecall({ id: id }).then(res => {
          if (res.code === 200) {
            this.msgSuccess(res.msg)
            this.getTables()
          } else {
            this.msgError(res.msg)
          }
        })
      })
    }
  }
}
</script>

<style scoped>
.span-row{
  margin: 0 10px;
}
</style>
